import React, { Component } from 'react';

import {Link} from 'react-router';

import {observer} from 'mobx-react';

class AboutPage extends Component {
  render() {
    return (
      <div>
        <div className="grid_8">
          <h1>About Us</h1>
          <p>We at Turner Roofing pride ourselves on exceptional standards with the opinion if a jobs worth doing its worth doing right. We use only the best quality materials using our tried and tested methods, ensuring time is taken to make sure all details are correct. By this we mean not only does the finished job look excellent but complies with all regulatory standards.</p>

          <p>All our working practices are done in a safe manor with all premises left as tidy as possible to cause minimal disruption so that daily routines can carry on as normal. We like to build up a good customer relationship meaning you yourselves feel safe in the knowledge that u will receive a job well done. By providing customers with photographic evidence you can see exactly what we see and can be happy with the work been done.</p>

          <p>Lastly we offer good competitive rates with free quotations and expert advice. Our work comes guaranteed and is done to the highest standards possible leaving you the customer satisfied.</p>
          </div>
          <div className="grid_8">
            <img src="/van.jpg" alt="Turner Roofing" className="thumbnail" style={{width: '95%'}} />
          </div>
          <div className="grid_16">
          <br /><br /><br />
          <div className="infobox">
            <Link to="/contact">Contact us for a free, no obligation estimate</Link>
            <p>Need an urgent roof repair? Or maybe just some friendly roofing advice? we're happy to help.</p>
            <br />
            <p className="big">
              <Link to="/contact">Send us an email</Link>
              {' '}
              or call: <span className="phone">07866 432026</span> (Mobile), <span className="phone">01904 793538</span> (Home)<br />
            </p>
          </div>
          </div>
      </div>
    );
  }
}


export default observer(['photos'])(AboutPage);




/** WEBPACK FOOTER **
 ** ./src/AboutPage.js
 **/